import actionCreatorFactory from 'typescript-fsa';
import { Category } from './categories.reducer';
const actionCreator = actionCreatorFactory('Categories');

export const updateCategoryEntities = actionCreator<{
  categories: {
    [key: number]: Category;
  };
  appId: number;
}>('ENTITIES_UPDATE');



// WEBPACK FOOTER //
// ./src/store/Entities/Categories/categories.actions.ts